// extracted by mini-css-extract-plugin
module.exports = {"tooltip-container":"Tooltip--tooltip-container--1Jp-G","tooltipContainer":"Tooltip--tooltip-container--1Jp-G","tooltip":"Tooltip--tooltip--3SWLC","arrow":"Tooltip--arrow--3C2QU"};